import React from 'react';
import { makeStyles } from '@material-ui/core';
import { format, parseISO } from 'date-fns';
import { Skeleton } from '@material-ui/lab';


const useStyles = makeStyles(theme => ({
  link: {
    display: 'block',
    height: '100%'
  },
  image: {
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: 'cover'
  }
}))


/**
 * Image preview.
 * @param {image} props 
 */
function ImagePreview(props) {
  const { image } = props;
  const classes = useStyles();

  if (!image) return <Skeleton variant='rect' height='100%' />;

  const date = parseISO(image.capturedAt);
  const dateLong = format(date, 'd/MM/yyyy h:mm a');

  return (
    <a
      href={image.urls.original}
      target='_blank'
      rel='noopener noreferrer'
      className={classes.link}
    >
      <img
        src={image.urls.medium}
        alt={`Captured at ${dateLong}.`}
        className={classes.image}
      />
    </a>
  );
}

export default ImagePreview;
